module.exports = __webpack_public_path__ + "img/logo.85163b50.png";